var map = {
	"./center/index": 302,
	"./center/index.vue": 302
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 795;


//////////////////
// WEBPACK FOOTER
// ./src/components/page/user ^\.\/.*$
// module id = 795
// module chunks = 7